module.exports = {
	query: {
		key: 'path', // The magic URL key
	},
	types: {
		path: 'path', // Use full paths `/<base_path>/<webstore_path>`
		query: 'query', // Use query param to store path `/<base_path>?_=urlenc(<webstore_path>)
		// Not entirely sure how hash would work yet. We use hashes in some places, but that's only bad if they're used as in-page anchors
		//hash: 'hash', // Use query param to store path `/<base_path>#urlenc(<webstore_path>)
	},
};
